import axios from 'axios';
import { setLocalStore, getLocalStore, clearLocalStore } from '../localStorage/index'
const APIURL = process.env.REACT_APP_BACKEND_URL;
const LOCAL_STORAGE_KEY_USER = process.env.REACT_APP_LOCAL_STORAGE_KEY_USER;
var headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
}

if (getLocalStore(LOCAL_STORAGE_KEY_USER)) {

    axios.defaults.headers = {
        Accept: "application/json",
        Authorization: `Bearer ${getLocalStore(LOCAL_STORAGE_KEY_USER).tokenDetails.token}`,
    };
}

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        clearLocalStore(true);
        window.location = '/auth/login';
    } else {
        return Promise.reject(error);
    }
});


export const apiCall = async (path, method, data, sizesCheck) => {
    if (method === 'POST') {
        headers["Content-Type"] = 'application/json';

        const requestData = {
            ...data
          };
      
          var res = await axios({
            method: method,
            url: sizesCheck ? path : `${APIURL}${path}`,
            headers,
            data: requestData,
          })
        .then(response => {
            if (path === 'masteradmin/login') {
                

                if (!response.data.hasError) {
                    
                    axios.defaults.headers = {
                        Authorization: `Bearer ${response.data.data.tokenDetails.token}`,
                    };
                    setLocalStore(LOCAL_STORAGE_KEY_USER, response.data.data);

                }

            }
            //console.log("API Response", response)
            return response;

        }).catch(error => {
            console.log("API Error", error)
            return error.response;
        })
    }
    else {

        var res = await axios({
            method: method,
            url: sizesCheck ? path : `${APIURL}${path}`,
            headers,

        }).then(response => {

            //console.log("API Response", response)
            return response;

        }).catch(error => {
            console.log("API Error", error)
            return error.response;
        })
    }

    return res;
}

export const apiFileUploadCall = async (path, method, data, sizesCheck) => {
    if (method === 'POST') {
        headers["Content-Type"] = 'multipart/form-data';
        var res = await axios({
            method: method,
            url: sizesCheck ? path : `${APIURL}${path}`,
            headers,
            data: data
        }).then(response => {
            if (path === 'masteradmin/login') {
                if (!response.data.hasError) {
                    axios.defaults.headers = {
                        Authorization: `Bearer ${response.data.data.tokenDetails.token}`,
                        businessId: null
                    };
                    setLocalStore(LOCAL_STORAGE_KEY_USER, response.data.data);

                }

            }
            //console.log("API Response", response)
            return response;

        }).catch(error => {
            console.log("API Error", error)
            return error.response;
        })
    }
    else {

        var res = await axios({
            method: method,
            url: sizesCheck ? path : `${APIURL}${path}`,
            headers,

        }).then(response => {

            //console.log("API Response", response)
            return response;

        }).catch(error => {
            console.log("API Error", error)
            return error.response;
        })
    }

    return res;
}

export const apiUploadCall = async (path, files, setPercentage) => {

    function getFormData(object) {
        const formData = new FormData();
        Object.keys(object).forEach(key => formData.append(key, object[key]));
        return formData;
    }

    var formData = new FormData();
    // formData.append('name','test.png')
    formData.append('file', { uri: files.filePath, name: files.fileName, type: files.contentType });
    headers["Content-Type"] = 'multipart/form-data';



    const onUploadProgress = (progressEvent) => {

        console.log('progress ', (progressEvent.loaded / progressEvent.total) * 99)

        setPercentage((file) => {
            file[files.index].progress = (progressEvent.loaded / progressEvent.total) * 99;

            console.log('progressEvent: ', file[files.index])
            return [...file]
        })
        // setPercentage(99);

    }

    const data = formData;
    //console.log('formData ', formData);
    // console.log('headers', headers)


    var res = await axios({
        method: 'POST',
        url: `${APIURL}${path}`,
        headers,
        // onUploadProgress,
        data: files,

    }).then(response => {

        console.log("API Response", response)


        return {
            ...response.data,
            file_path: `${response.data.storage}${response.data.file_path}`,

        };

    }).catch(error => {
        console.log("API Error", error)
        return error.response;
    })


    return res;
}

export const logoutUser = async () => {
    axios.defaults.headers = {

    };
    clearLocalStore(true);

    return true;
}